<div class="container margin-top">
  <div class="row margin-bottom">
    <div class="col-md-12">
      <md-card>
        <div class="row">
          <div class="col-md-4">
            <p>What is the email you're sending to?</p>
            <p-autoComplete class="full-width"
                            [(ngModel)]="emailTracker.to"
                            [suggestions]="filteredEmails"
                            name="email"
                            (completeMethod)="filter($event, 'emails')"
                            type="email"
                            [minLength]="1"></p-autoComplete>
            <p>What is your email?</p>
            <p-autoComplete class="full-width"
                            [(ngModel)]="emailTracker.from"
                            [suggestions]="filteredEmails"
                            name="email"
                            (completeMethod)="filter($event, 'emails')"
                            type="email"
                            [minLength]="1"></p-autoComplete>

            <p>Name of person receiving the email?</p>
            <input type="text"
                   [(ngModel)]="emailTracker.name"
                   pInputText
                   class="full-width">

            <p>Title:</p>
            <input type="text"
                   [(ngModel)]="emailTracker.title"
                   pInputText
                   class="full-width">

          </div>
          <div class="col-md-4">
            <p>Facility Name</p>
            <p-autoComplete class="full-width"
                            [(ngModel)]="emailTracker.facilityName"
                            [suggestions]="filteredFacilityName"
                            name="facilityName"
                            (completeMethod)="filter($event, 'facilityNames')"
                            type="facilityName"
                            [minLength]="1"></p-autoComplete>

            <p>Website:</p>
            <input type="text"
                   [(ngModel)]="emailTracker.website"
                   pInputText
                   class="full-width">

            <p>Note</p>
            <textarea type="text"
                      [(ngModel)]="emailTracker.notes"
                      pInputTextarea
                      class="full-width tall"></textarea>



          </div>
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-12">
                <p>Tags</p>
                <span class="ui-fluid">
                  <p-autoComplete [(ngModel)]="emailTracker.tags"
                                  [suggestions]="filteredTags"
                                  name="tags"
                                  (completeMethod)="filter($event, 'tags')"
                                  type="tags"
                                  [multiple]="true"
                                  [inputStyleClass]="'full-width'"
                                  [minLength]="1"></p-autoComplete>
                </span>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <p>Status</p>
                <p-dropdown [options]="status"
                            class="full-width"
                            [(ngModel)]="emailTracker.status"></p-dropdown>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <p>City</p>
                <span class="ui-fluid">
                  <p-autoComplete class="full-width"
                                  [(ngModel)]="emailTracker.city"
                                  [suggestions]="filteredCities"
                                  name="cities"
                                  (completeMethod)="filter($event, 'cities')"
                                  type="cities"
                                  [minLength]="1"></p-autoComplete>
                </span>
              </div>
              <div class="col-md-6">
                <p>State</p>
                <span class="ui-fluid">
                  <p-autoComplete class="full-width"
                                  [(ngModel)]="emailTracker.state"
                                  [suggestions]="filteredStates"
                                  name="state"
                                  (completeMethod)="filter($event, 'states')"
                                  type="state"
                                  [minLength]="1"></p-autoComplete>
                </span>
              </div>
            </div>

            <button (click)="makeNewTracker()"
                    class="btn btn-primary float-right margin-top"
                    color="primary">Create</button>

            <div *ngIf="imageUrl"
                 class="text-center">
              <h2>Image Link URL</h2>
              <p>Add this in the email you are about to send. Then once sent, set it to active.</p>
              <p><b>{{imageUrl}}</b></p>
            </div>
          </div>
        </div>
      </md-card>
    </div>
  </div>


  <div class="row">
    <div class="col-md-12">
      <md-card class="margin-bottom">
        <div class="ui-widget-header"
             style="padding:4px 10px;border-bottom: 0 none">
          <i class="fa fa-search"
             style="margin:4px 4px 0 0"></i>
          <input #gb
                 type="text"
                 pInputText
                 placeholder="Search"
                 style="width: 250px !important;">
        </div>
        <p-dataTable [value]="et.emailTrackersArray"
                     [sortField]="'date'"
                     [sortOrder]="-1"
                     [rows]="25"
                     [editable]="true"
                     [responsive]="true"
                     [paginator]="true"
                     expandableRows="true"
                     (onEditComplete)="updateEmailTracker($event)"
                     [globalFilter]="gb"
                     [immutable]="false"
                     #dt>
          <p-column expander="true"
                    styleClass="col-icon"></p-column>
          <p-column field="status"
                    styleClass="text-center"
                    header="Status"
                    [sortable]="true">
            <ng-template let-col
                         let-car="rowData"
                         pTemplate="body">
              <md-chip-list>
                <md-chip selected="true"
                         class="col-status"
                         [ngStyle]="{'background': colors[car[col.field]]}">{{car[col.field]}}</md-chip>
              </md-chip-list>
            </ng-template>
          </p-column>
          <p-column field="facilityName"
                    header="Facility Name"
                    [sortable]="true"
                    [editable]="true"
                    filterPlaceholder="Search"
                    [filter]="true"></p-column>
          <p-column field="date"
                    header="Date"
                    styleClass="col-date"
                    [sortable]="true">
            <ng-template let-col
                         let-car="rowData"
                         pTemplate="body">
              {{ car[col.field] | date}}
            </ng-template>
          </p-column>
          <p-column field="numViews"
                    header="Views"
                    styleClass="col-views"
                    [sortable]="true">
            <ng-template let-col
                         let-car="rowData"
                         pTemplate="body">
              <h3><b>{{ car[col.field] }}</b></h3>
            </ng-template>
          </p-column>
          <p-column field="tags"
                    header="Tags"
                    styleClass="col-tags">
            <ng-template let-col
                         let-car="rowData"
                         pTemplate="body">
              <p-autoComplete [(ngModel)]="car[col.field]"
                              [suggestions]="filteredTags"
                              name="tags"
                              (completeMethod)="filter($event, 'tags')"
                              type="tags"
                              [multiple]="true"
                              (onSelect)="updateStatus(car)"
                              (onUnselect)="updateStatus(car)"
                              [inputStyleClass]="'full-width'"
                              [minLength]="1"></p-autoComplete>
            </ng-template>
          </p-column>
          <p-column field="to"
                    header="To"
                    class="to"
                    [sortable]="true"
                    [filter]="true"
                    filterPlaceholder="Search"
                    [editable]="true">

          </p-column>
          <p-column field="from"
                    header="From"
                    [sortable]="true"
                    [editable]="true"
                    filterPlaceholder="Search"
                    [filter]="true">

          </p-column>
          <p-column field="id"
                    header="Notifications?"
                    styleClass="col-toggle"
                    [sortable]="true">
            <ng-template let-col
                         let-car="rowData"
                         pTemplate="body">
              <md-slide-toggle (change)="toggleNotifications(car[col.field])"
                               [(ngModel)]="et.emailTrackers[car[col.field]].isNotifications"></md-slide-toggle>
            </ng-template>
          </p-column>
          <p-column field="id"
                    header="Active?"
                    styleClass="col-toggle"
                    [sortable]="true">
            <ng-template let-col
                         let-car="rowData"
                         pTemplate="body">
              <md-slide-toggle (change)="toggleActive(car[col.field])"
                               [(ngModel)]="et.emailTrackers[car[col.field]].isActive"></md-slide-toggle>
            </ng-template>
          </p-column>
          <ng-template let-car
                       pTemplate="rowexpansion">
            <div class="ui-grid ui-grid-responsive ui-fluid"
                 style="font-size:16px;padding:20px">
              <div class="ui-grid-col-12">
                <div class="ui-grid ui-grid-responsive ui-grid-pad">
                  <div class="ui-grid-row">
                    <div class="ui-grid-col-3 label views left">Image Link: </div>
                    <div class="ui-grid-col-3 left">{{car.imgUrl}}</div>
                    <div class="ui-grid-col-3 views left">Status</div>
                    <div class="ui-grid-col-3 left">
                      <p-dropdown [options]="status"
                                  (onChange)="updateStatus(car)"
                                  class="full-width"
                                  [(ngModel)]="car.status"></p-dropdown>
                    </div>
                  </div>
                  <div class="ui-grid-row">
                    <div class="ui-grid-col-3 label views left">Recipient Name: </div>
                    <div class="ui-grid-col-3 left">{{car?.name}}</div>
                    <div class="ui-grid-col-3 label views left">Title: </div>
                    <div class="ui-grid-col-3 left">{{car?.title}}</div>
                  </div>
                  <div class="ui-grid-row">
                    <div class="ui-grid-col-3 label views left">Website: </div>
                    <div class="ui-grid-col-3 left"><a href="{{car?.website}}"
                         target="_blank">{{car?.website}}</a></div>
                    <div class="ui-grid-col-3 label views left">Location: </div>
                    <div class="ui-grid-col-3 left">{{car?.city}}, {{car?.state}}</div>
                  </div>
                  <br>
                  <div *ngIf="car?.urls.length > 0"
                       class="ui-grid-row">
                    <div class="ui-grid-col-3 label views left">Links: </div>
                    <div class="ui-grid-col-3 views left">URL</div>
                    <div class="ui-grid-col-3 views left">Clicks</div>
                  </div>
                  <div class="ui-grid-row"
                       *ngFor="let url of car?.urls">
                    <div class="ui-grid-col-3 label left">{{url.short}}</div>
                    <div class="ui-grid-col-3 left">{{url.full}}</div>
                    <div class="ui-grid-col-3 date left">
                      <b>{{car?.clicks[url.short]}}</b>
                    </div>
                    <div class="ui-grid-col-3 date left">
                      <button class="btn btn-default"
                              (click)="goToLinkGraph(url.short)">Stats</button>
                    </div>
                  </div>
                  <div class="ui-grid-row">
                    <div class="ui-grid-col-3 label views left">Notes: </div>
                    <div class="ui-grid-col-9 left"></div>
                  </div>
                  <div class="ui-grid-row"
                       *ngFor="let note of car?.notes">
                    <div class="ui-grid-col-3 label right">*</div>
                    <div class="ui-grid-col-9 left">{{note}}</div>
                  </div>

                  <div class="ui-grid-row">
                    <div class="ui-grid-col-6 label right">
                      <textarea type="text"
                                [(ngModel)]="newNote"
                                pInputTextarea
                                class="full-width tall"></textarea>
                      <button (click)="addNewNote(car)"
                              class="btn btn-default sm-margin-top float-right"
                              color="primary">Add Note</button>
                    </div>
                    <div class="ui-grid-col-6 left">
                      <input type="text"
                             [(ngModel)]="newUrl"
                             pInputText
                             class="full-width">
                      <button (click)="addNewUrl(car.id)"
                              class="btn btn-default  sm-margin-top float-right"
                              color="primary">Add URL</button>
                      <br>
                      <button (click)="addSpecificUrl(car.id, 'video')"
                              class="btn btn-default sm-margin-top">Add Video URL</button>
                      <button (click)="addSpecificUrl(car.id, 'demo')"
                              class="btn btn-default sm-margin-top">Add Demo URL</button>
                      <button (click)="addSpecificUrl(car.id, 'storagepug')"
                              class="btn btn-default sm-margin-top">Add StoragePug URL</button>
                    </div>
                  </div>

                  <br><br>
                  <div *ngFor="let view of car.viewData"
                       class="ui-grid-row">
                    <div class="ui-grid-col-3 label views left"><b>View:</b> </div>
                    <div class="ui-grid-col-9 date">{{view.viewed_on | date:'medium' }}</div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </p-dataTable>
      </md-card>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/email-tracker/email-tracker.component.html